import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AnchorButton from '../../../button/AnchorButton';
import './SocialSignInButton.scss';

var SocialSignInButton = function SocialSignInButton(_ref) {
  var onClick = _ref.onClick,
      href = _ref.href,
      className = _ref.className,
      logo = _ref.logo,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(AnchorButton, {
    className: classNames('SocialSignInButton', className),
    onClick: onClick,
    href: href
  }, /*#__PURE__*/React.createElement("span", {
    className: "logo-container"
  }, logo), /*#__PURE__*/React.createElement("span", {
    className: "text"
  }, children));
};

SocialSignInButton.propTypes = {
  onClick: PropTypes.func,
  href: PropTypes.string,
  className: PropTypes.string,
  logo: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
export default SocialSignInButton;